"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pendingConditionExtendedSchema = void 0;
var pending_condition_code_1 = require("./pending-condition-code");
var pending_condition_schema_1 = require("./pending-condition-schema");
exports.pendingConditionExtendedSchema = __assign(__assign({}, pending_condition_schema_1.pendingConditionSchema), { allOf: [
        {
            if: {
                properties: {
                    code: {
                        const: pending_condition_code_1.PendingConditionCode.Other,
                    },
                },
            },
            then: {
                required: ['otherDescription'],
                errorMessage: 'should have the required property - otherDescription',
                properties: {
                    otherDescription: {
                        type: 'string',
                        minLength: 1,
                        maxLength: 200,
                    },
                },
            },
        },
    ] });
